import * as moment from 'moment';

export function formatDateAvailable(value) {
  return moment(value).format("ddd, Do MMM");
}
